<template>
  <v-card>
    <v-toolbar
      dense
      card
      class="elevation-2"
      @click.stop="showProposal = !showProposal"
    >
      <v-toolbar-title class="body-2 beez-bold ">
        {{ title }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <transition name="fade" mode="out-in" v-if="!designer && showProposal">
        <v-tooltip bottom>
          <v-btn flat icon slot="activator" @click.stop="designer = true">
            <v-icon>edit</v-icon>
          </v-btn>
          <span>Edit proposals</span>
        </v-tooltip>
      </transition>
      <transition name="fade" mode="out-in" v-if="designer">
        <v-tooltip bottom>
          <v-btn flat icon slot="activator" @click.stop="save">
            <v-icon>save</v-icon>
          </v-btn>
          <span>Save proposals</span>
        </v-tooltip>
      </transition>
      <transition name="fade" mode="out-in" v-if="designer">
        <v-tooltip bottom>
          <v-btn flat icon slot="activator" @click.stop="cancel">
            <v-icon>close</v-icon>
          </v-btn>
          <span>Cancel</span>
        </v-tooltip>
      </transition>
      <transition name="fade" mode="out-in" v-if="!designer">
        <v-btn flat icon @click.stop="showProposal = !showProposal">
          <v-icon>
            {{ showProposal ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </v-icon>
        </v-btn>
      </transition>
    </v-toolbar>
    <transition name="bounce" mode="out-in">
      <v-card-text v-show="showProposal">
        <div v-if="!designer">
          <proposal-renderer
            :proposals="proposals"
            :readonly="true"
            :cancel="true"
            v-if="proposals.length > 0"
          >
          </proposal-renderer>
          <template v-else
            >No Inputs found
          </template>
        </div>
        <div v-else-if="designer">
          <proposal-designer
            :value="proposals"
            @input="updateProposals"
          ></proposal-designer>
        </div>
      </v-card-text>
    </transition>
  </v-card>
</template>

<script>
import ProposalDesigner from '../bot-creation/ProposalDesigner'
import ProposalRenderer from './ProposalRenderer'

export default {
  components: {
    ProposalRenderer,
    ProposalDesigner
  },
  name: 'InputProposal',
  props: {
    title: {
      type: String,
      default: 'Input proposals'
    },
    inputProposal: Array
  },
  data: function() {
    return {
      showProposal: false,
      designer: false,
      proposals: []
    }
  },
  created() {
    this.setProposal()
  },
  methods: {
    setProposal() {
      if (
        typeof this.inputProposal !== 'undefined' &&
        this.inputProposal &&
        this.inputProposal.length > 0
      ) {
        this.proposals = this.inputProposal
      } else {
        this.proposals = []
      }
    },
    updateProposals(value) {
      this.proposals = value
    },
    save() {
      this.designer = false
      this.$emit('save', this.proposals)
    },
    cancel() {
      this.designer = false
      this.setProposal()
    }
  }
}
</script>

<style scoped></style>
